import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { GroupedDish, formatElapsedTime, getTimeColor, isLateOrder } from './kdsHelpers';

interface GroupedDishCardProps {
  dish: GroupedDish;
}

/** Read-only card for the "Agrupar por platillo" view: one dish across all open orders. */
const GroupedDishCard: React.FC<GroupedDishCardProps> = ({ dish }) => {
  const late = isLateOrder(dish.elapsedSeconds);

  return (
    <div className={`kds-card ${late ? 'kds-card--late' : 'kds-card--prep'}`}>
      <div className="kds-card__head">
        <div className="kds-dish__name">
          <span className="kds-item__qty">{dish.totalQuantity}×</span> {dish.productName}
          {dish.variants && (
            <div className="kds-item__variants" style={{ marginLeft: 0 }}>({dish.variants})</div>
          )}
        </div>
        <div
          className={`kds-timer${late ? ' kds-timer--late' : ''}`}
          style={late ? undefined : { color: getTimeColor(dish.elapsedSeconds) }}
        >
          {formatElapsedTime(dish.elapsedSeconds)}
        </div>
      </div>

      <div className="kds-dish__orders">
        {dish.orders.map((orderInfo, index) => (
          <div key={`${orderInfo.orderId}-${index}`} className="kds-dish__order-row">
            <b>{orderInfo.tableName}</b>
            <span className="kds-dish__order-qty">{orderInfo.quantity}×</span>
            {orderInfo.notes && (
              <div className="kds-item__note" style={{ marginLeft: 0, width: '100%' }}>
                Nota: {orderInfo.notes}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="kds-dish__hint">
        <UnorderedListOutlined /> Cambia a vista por orden para marcar como listo
      </div>
    </div>
  );
};

export default GroupedDishCard;
